export default __webpack_public_path__ + "static/media/cellc_cadvance.0ad146be.png";